import React, { useState } from "react";
import { Table, Icon, Button, Modal } from "semantic-ui-react";
import EditModal from '../../modals/editModal';
import AddVendorBranchModal from './add_branch_modalnew';
import AddVendorBranchDetailsModal from './branch_details_modalNew'
import DeleteModal from "../../modals/deleteModal";
import DeleteAxios from "../../axiosComponent/delete";
import cogoToast from 'cogo-toast';
import {vendor_branch} from './vendorConstants'

const BranchTable = ({branchData, vendorId}) => {

    const [openBranchAddModal, setOpenBranchAddModal] = useState(false)
    const [openBranchDetailsModal, setOpenBranchDetailsModal] = useState(false)
    const [branchDetailData, setBranchDetailData] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [currentObj, setCurrentObj] = useState()
    const [deletObjId, setDeleteObjId] = useState()

    const branchAddModal = () => {
        setCurrentObj(null)
        setOpenBranchAddModal(true)
    }

    const handleCloseBranchModal = () => {
        setOpenBranchAddModal(false)
        setDeleteModalOpen(false)
    }

    const branchDetailsModal = (branch) => {
        setBranchDetailData(branch)
        setOpenBranchDetailsModal(true)
    }

    const handleCloseBranchDetails = () => {
        setOpenBranchDetailsModal(false)
    }
    const openEditModal = (obj)=>{
        setCurrentObj(obj)
        setOpenBranchAddModal(true)
    }
    const openDeleteModal = (obj)=> {
        setDeleteObjId(obj.vendorBranchId)
        setDeleteModalOpen(true)
    }
    const confirmDelete = ()=>{
        DeleteAxios({
        url: `vendorBranch`,
        uniqueId:deletObjId
        }).then((response)=>{
            if(response?.data?.status==200){
                cogoToast.success(response.data.message, { position: 'top-right' })
                setTimeout(() => { window.location.reload() }, 1000)
            }else{
                cogoToast.error(response?.data?.message, { position: 'top-right' })
            }
        }).catch((err)=>{
            console.log(err);
        })
    }


    return (
        <>
            <Table stackable size="small" selectable>
                <Table.Header className="w3-small">
                    <Table.Row>
                        <Table.HeaderCell colSpan="6" className="p-bold-600">
                            {vendor_branch?.titles?.branch_details||"Branch Details"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-600" textAlign="right">
                            <Button
                            type="button"
                            className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                            add_mode="add"
                            onClick={branchAddModal}
                            >
                                <Icon name="plus" /> {vendor_branch?.buttons?.new||"New"}
                            </Button>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.branch||"Branch"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.gst_no||"GST Number"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.address||"Address"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.pincode||"Pincode"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.more_details||"More Details"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.edit||"Edit"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_branch?.headers?.delete||"Delete"}
                        </Table.HeaderCell>
                    </Table.Row>            
                </Table.Header>
                <Table.Body>
                    {branchData && branchData.length > 0 ? 
                        (
                            branchData.map((branch,branchIndex) => (
                                <Table.Row key={branchIndex}>
                                    <Table.Cell className="fixedLength150">
                                        {branch.vendorBranchName}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {branch.vendorBranchGST}
                                    </Table.Cell>
                                    <Table.Cell className="fixedLength150">
                                        {branch.vendorBranchAddress}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {branch.vendorBranchPincode}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Button onClick={() => branchDetailsModal(branch)} basic icon size="mini"><Icon name="eye" ></Icon></Button>
                                    </Table.Cell>
                                    <EditModal size="medium" open={openBranchDetailsModal} onClose={handleCloseBranchDetails}>
                                        <Modal.Header>Branch Details</Modal.Header>
                                        <AddVendorBranchDetailsModal handleCloseBranchDetails={handleCloseBranchDetails} data={branchDetailData} />
                                    </EditModal>
                                    <Table.Cell>
                                        <Button onClick={() => openEditModal(branch)} basic icon size="mini"><Icon name="edit" color="green" ></Icon></Button>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Button onClick={() => openDeleteModal(branch)} basic icon size="mini"><Icon name="trash" color="red" ></Icon></Button>
                                    </Table.Cell>
                                </Table.Row>
                                
                                

                            ))
                        )
                    :
                        (
                            <Table.Row>
                                <Table.Cell colSpan="6">No Records Found</Table.Cell>
                            </Table.Row>
                        )      
                    }
                </Table.Body>
            </Table>
            <EditModal size="small" open={openBranchAddModal} onClose={handleCloseBranchModal}>
                <Modal.Header>{currentObj? vendor_branch?.titles?.edit_title : vendor_branch?.titles?.add_title }</Modal.Header>
                <AddVendorBranchModal handleCloseEdit={handleCloseBranchModal} vendorId={vendorId} editData={currentObj}/>
            </EditModal>

            <DeleteModal
            open={deleteModalOpen}
            onClose = {handleCloseBranchModal}
            handleDelete = {confirmDelete}
            />
        </>
    )
}

export default BranchTable